import React from "react";
import CheckoutPage from "../components/CheckoutPage";

const ShoppingCart = () => {
  return <CheckoutPage />;
};

export default ShoppingCart;
